import styled from 'styled-components';

export const Title = styled.h2`
  margin: 3% 3% 1% 3%;
  color: #1e3b69;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
  margin: 0% 3% 3% 3%;
  border-radius: 3px;
  background-color: white;
  div {
    padding: 10px;
    div {
      padding: 0px;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  filter: drop-shadow(0px 2px 9px rgba(0, 0, 0, 0.2));
`;

export const BtSeeMore = styled.button`
  color: blue;
  cursor: pointer;
  text-align: right;
  width: 100%;
`;
